import React from 'react';
import { useDispatch } from 'react-redux';
import { Main } from '../../components';
import { setCreditData } from '../../store/features/loans/loans.slice';
import { onCalculateLoan } from '../../utils/business';
import CredentialsForm from './components/CredentialsForm/CredentialsForm';
import CreditCalculationData from './components/CreditCalculationData/CreditCalculationData';
import PaymentSchedule from './components/PaymentSchedule/PaymentSchedule';
import { CreditCredentials } from './utils';

const Loans: React.FC = () => {
    const dispatch = useDispatch();

    const handleSubmit = (data: CreditCredentials) => {
        const results = onCalculateLoan(
            Number(data.amount),
            Number(data.percent),
            Number(data.period),
            Number(data.daysInMonth),
            Number(data.daysInYear),
        );

        dispatch(
            setCreditData({
                ...data,
                ...results,
            }),
        );
    };

    return (
        <Main active={0}>
            <CredentialsForm results={<CreditCalculationData />} onSubmit={handleSubmit} />

            <PaymentSchedule />
        </Main>
    );
};

export default Loans;
